// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/@vue/cli-service/node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".flexwrap[data-v-ba15c758]{flex-wrap:wrap}.countbox[data-v-ba15c758]{min-width:150px;width:12.5%;margin-bottom:10px}", ""]);
// Exports
module.exports = exports;
